const config = {
  apiGateway: {
    REGION: 'ap-southeast-2',
    INTERNAL_API_URL: 'https://yf7qwy6b17.execute-api.ap-southeast-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://t2bfghumx2.execute-api.ap-southeast-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.staging.ozminerals.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'Australia/Sydney'
  },
  reactApp: {
    VERSION: 'targets-1.12.2',
    HOSTNAME: 'https://targets.staging.ozminerals.forwoodsafety.com'
  }
};

export default config;